// extracted by mini-css-extract-plugin
export default {"icon":"PaymentProtectionBanner--icon--30c94e","banner":"PaymentProtectionBanner--banner--bef8ad"};